export const useMediumLink = (key) => {
    switch (key) {
        case "NewBuild":
            return "?m=classified_detail_to_the_project_project_classified_detail";
        case "SellerLead":
            return "?m=classified_detail_estimate_estimate_landing";
        case "MediumRectangleTop": // Farbwelt
            return "?m=classified_detail_farbwelt_first_rectangle_intermediary_detail_page";
        case "MediumRectangleBottom": // Farbwelt
            return "?m=classified_detail_farbwelt_second_rectangle_intermediary_detail_page";
        case "MobileBanner": // Farbwelt
            return "?m=classified_detail_farbwelt_mobile_banner_intermediary_detail_page";
        case "profileURL":
            return "?m=classified_detail_edit_contact_details_account_login";
        case "schufaRentLink":
            return "?m=classified_detail_contextual_entry_landing_schufa";
        default:
            return null;
    }
};
